const removeArrayItem = (arr, el) => {
  const i = arr.indexOf(el);
  if (i > -1) {
    arr.splice(i, 1);
  }
};
const uniqArray = (arr) => {
  if (!arr || !arr.length) {
    return [];
  }
  return Array.from(new Set(arr));
};

const isNull = (val) => val === null;

const isUndefined = (val) => val === void 0 || typeof val === "undefined";

const isString = (val) => typeof val === "string";

const isNumber = (val) => typeof val === "number";

const isSymbol = (val) => typeof val === "symbol";

const isFunction = (val) => typeof val === "function";

const hasOwnProperty = Object.prototype.hasOwnProperty;
const getPrototypeOf = Object.getPrototypeOf;
const objectToString = Object.prototype.toString;
const toTypeString = (val) => objectToString.call(val);

const ARRAY_TAG = "[object Array]";
const DATE_TAG = "[object Date]";
const MAP_TAG = "[object Map]";
const OBJECT_TAG = "[object Object]";
const SET_TAG = "[object Set]";
const randomLetters = [
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z"
];

const isObject = (val) => {
  return typeof val === "object" && !isNull(val);
};

const isArray = (val) => {
  if (Array.isArray) {
    return Array.isArray(val);
  }
  return isObject(val) && toTypeString(val) === ARRAY_TAG;
};

const getPrototype = (val) => getPrototypeOf(val);

const isPlainObject = (val) => {
  if (!isObject(val) || toTypeString(val) !== OBJECT_TAG) {
    return false;
  }
  if (getPrototype(val) === null) {
    return true;
  }
  let proto = val;
  while (getPrototype(proto) !== null) {
    proto = getPrototype(proto);
  }
  return getPrototype(val) === proto;
};

const isMap = (val) => {
  return isObject(val) && toTypeString(val) === MAP_TAG;
};

const isSet = (val) => {
  return isObject(val) && toTypeString(val) === SET_TAG;
};

const isDate = (val) => {
  return isObject(val) && toTypeString(val) === DATE_TAG;
};

const isPromise = (val) => {
  return isObject(val) && isFunction(val.then) && isFunction(val.catch);
};

const isElement = (el) => {
  if (isUndefined(Element)) {
    return false;
  }
  return el instanceof Element;
};

const oneDayMilliseconds = 864e5;
const isValidDate = (val) => {
  if (!isDate(val)) {
    val = new Date(val);
  }
  return !Number.isNaN(val.valueOf());
};
const getTwoDaysDiffMS = (d1, d2) => Math.ceil(Math.abs(d1.getTime() - d2.getTime()) / oneDayMilliseconds);
const getDayOfYear = (date) => ~~((date.getTime() - new Date(date.getFullYear(), 0, 0).getTime()) / oneDayMilliseconds);
const getTimeFromDate = (date) => date.toTimeString().slice(0, 8);
const getNowTimeStr = () => new Date().toLocaleString().replaceAll("/", "-");

const formatMemoryToMB = (val) => `${(val / 1024 / 1024).toFixed(2)}MB`;
const formatMsToSecordsStr = (val) => `${~~(val / 1e3)}s`;
const getBrowserInfo = () => {
  return new Promise((resolve) => {
    const browserInfos = {};
    if (document) {
      const { domain, URL, title, referrer } = document;
      browserInfos.domain = domain || "";
      browserInfos.url = URL || "";
      browserInfos.title = title || "";
      browserInfos.referrer = referrer || "";
    }
    if (window?.screen) {
      const { height, width, colorDepth } = window.screen;
      browserInfos.screenHeight = height || 0;
      browserInfos.screenWidth = width || 0;
      browserInfos.color = colorDepth || 0;
    }
    if (navigator) {
      const { language, userAgent } = navigator;
      browserInfos.lang = language || "";
      browserInfos.ua = userAgent.toLowerCase();
    }
    if (window?.performance) {
      browserInfos.memory = formatMemoryToMB(window.performance?.memory?.usedJSHeapSize);
      const timing = window.performance?.timing || {};
      browserInfos.connectTime = formatMsToSecordsStr(timing.connectEnd - timing.connectStart);
      browserInfos.responseTime = formatMsToSecordsStr(timing.responseEnd - timing.responseStart);
      browserInfos.renderTime = formatMsToSecordsStr(timing.domComplete - timing.domLoading);
    }
    browserInfos.watchTime = getNowTimeStr();
    resolve(browserInfos);
  });
};

const sohuIpAddressUrl = "http://pv.sohu.com/cityjson?ie=utf-8";
const getUserIp = () => {
  return new Promise((resolve, reject) => {
    const scriptElement = document.createElement("script");
    scriptElement.src = sohuIpAddressUrl;
    document.body.appendChild(scriptElement);
    scriptElement.onload = () => {
      try {
        document.body.removeChild(scriptElement);
        resolve(window.returnCitySN);
      } catch (e) {
        reject(e);
      }
    };
  });
};

const copyToClipboard = (text) => navigator.clipboard.writeText(text);
const getSelectedText = () => window.getSelection()?.toString();
const isDarkMode = window?.matchMedia("(prefers-color-scheme: dark)").matches;
const isAppleDevice = /Mac|iPhone|iPad|iPod/ig.test(navigator.userAgent);

const getRandomNum = (min = 0, max = 100) => {
  return ~~(Math.random() * (max - min) + min);
};
const getAverage = (...args) => {
  const len = args.length;
  if (len === 0) {
    return 0;
  }
  return Number(args.reduce((prev, next) => prev + next, 0).toFixed(2));
};

const RegEx_Email = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
const RegEx_Domain = /[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+\.?/;
const RegEx_Password = /^[a-zA-Z]\w{5,17}$/;
const RegEx_StrongPassword = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,16}$/;
const RegEx_PhoneNumber = /^(13[0-9]|14[5|7]|15[0|1|2|3|5|6|7|8|9]|18[0|1|2|3|5|6|7|8|9])\d{8}$/;

const isDomainName = (val) => RegEx_Domain.test(val);
const isEmail = (val) => RegEx_Email.test(val);
const isPhoneNumber = (val) => RegEx_PhoneNumber.test(val);

const capitalizeStr = (str) => `${str.charAt(0).toUpperCase()}${str.slice(1)}`;

const reverseStr = (str) => str.split("").reverse().join("");

const generateRandomStr = (randomStrLen = 10, letters) => {
  if (!letters || !isArray(letters)) {
    letters = randomLetters;
  }
  const len = letters.length;
  let res = "";
  for (let i = 0; i < randomStrLen; i++) {
    res += letters[getRandomNum(0, len)];
  }
  return res;
};

const truncateStr = (str, len) => {
  if (len === void 0) {
    return str;
  }
  return str.length < len ? str : `${str.slice(0, len - 3)}...`;
};

const stripHtmlEl = (htmlStr) => new DOMParser().parseFromString(htmlStr, "text/html").body.textContent || "";

const convertRgbToHex = (r, g, b) => {
  if (r < 0 || r > 255 || g < 0 || g > 255 || b < 0 || b > 255) {
    throw new Error("s");
  }
  return `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)}`;
};

const generateRandomHex = () => `#${(~~(Math.random() * 16777215)).toString(16).padEnd(6, "0")}`;

const toString = (val) => {
  if (isNull(val) || isUndefined(val)) {
    return "";
  }
  if (isString(val)) {
    return val;
  }
  if (isSymbol(val)) {
    return val.toString();
  }
  if (isArray(val)) {
    return `${val.map((item) => item === null ? item : toString(item))}`;
  }
  const result = `${val}`;
  return result === "0" && 1 / Number(val) === -Infinity ? "-0" : result;
};

const hasOwnProp = (val, key) => hasOwnProperty.call(val, key);
const hasChanged = (value, oldValue) => !Object.is(value, oldValue);

const color = {
  white: "#FFFFFF",
  black: "#000000",
  cyan: "#51C4D3",
  red: "#C02C38",
  green: "#42C02E",
  yellow: "#F1CA17",
  blue: "#15559A"
};
const SPLIT_TAG = "__styles__";
const leftPaddingStyle = "padding: 2px 1px; border-radius: 3px 0 0 3px;";
const rightPaddingStyle = "padding: 2px 1px; border-radius: 0 3px 3px 0;";
const sureUtilsPrefix = `sure-utils${SPLIT_TAG}${leftPaddingStyle}background: ${color.blue}; font-weight: bold; color: ${color.white};`;
const tipPrefix = `tip${SPLIT_TAG}${rightPaddingStyle} background: ${color.green}; font-weight: bold; color: ${color.white};`;
const warnPrefix = `warn${SPLIT_TAG}${rightPaddingStyle} background: ${color.yellow}; font-weight: bold; color: ${color.white};`;
const errorPrefix = `error${SPLIT_TAG}${rightPaddingStyle} background: ${color.red}; font-weight: bold; color: ${color.white};`;

const _console = console;
const addStyle = (str, styles) => {
  const strArr = str.split(SPLIT_TAG);
  strArr[1] = strArr[1] ? `${strArr[1]}${styles};` : styles;
  return strArr.join(SPLIT_TAG);
};
const colorUtils = {
  bold: (str) => {
    return addStyle(str, "font-weight: bold;");
  },
  white: (str) => {
    return addStyle(str, `color: ${color.white};`);
  },
  black: (str) => {
    return addStyle(str, `color: ${color.black};`);
  },
  cyan: (str) => {
    return addStyle(str, `color: ${color.cyan};`);
  },
  red: (str) => {
    return addStyle(str, `color: ${color.red};`);
  },
  green: (str) => {
    return addStyle(str, `color: ${color.green};`);
  },
  blue: (str) => {
    return addStyle(str, `color: ${color.blue};`);
  },
  bgWhite: (str) => {
    return addStyle(str, `background: ${color.white};`);
  },
  bgBlack: (str) => {
    return addStyle(str, `background: ${color.black};`);
  },
  bgCyan: (str) => {
    return addStyle(str, `background: ${color.cyan};`);
  },
  bgRed: (str) => {
    return addStyle(str, `background: ${color.red};`);
  },
  bgGreen: (str) => {
    return addStyle(str, `background: ${color.green};`);
  },
  bgBlue: (str) => {
    return addStyle(str, `background: ${color.blue};`);
  }
};
const generateLogMsg = (...msgs) => {
  let msgRes = "";
  const stylesRes = [];
  for (const item of msgs) {
    const [msg, style] = item.split(SPLIT_TAG);
    msgRes += `%c ${msg} `;
    stylesRes.push(style);
  }
  return [msgRes, ...stylesRes];
};
const tipLog = (...args) => {
  const msgs = generateLogMsg(sureUtilsPrefix, tipPrefix, ...args);
  _console.log(...msgs);
};
const warnLog = (...args) => {
  const msgs = generateLogMsg(sureUtilsPrefix, warnPrefix, ...args);
  _console.warn(...msgs);
};
const errorLog = (...args) => {
  const msgs = generateLogMsg(sureUtilsPrefix, errorPrefix, ...args);
  _console.error(...msgs);
};

function debounce(func, waitMilliseconds = 50, options = {}) {
  let timerId;
  const isImmediate = options.isImmediate ?? false;
  const callback = options.callback ?? false;
  const maxWait = options.maxWait;
  let lastInvokeTime = Date.now();
  let promises = [];
  function nextInvokeTimeout() {
    if (maxWait !== void 0) {
      const timeSinceLastInvocation = Date.now() - lastInvokeTime;
      if (timeSinceLastInvocation + waitMilliseconds >= maxWait) {
        return maxWait - timeSinceLastInvocation;
      }
    }
    return waitMilliseconds;
  }
  const debouncedFunction = function(...args) {
    const context = this;
    return new Promise((resolve, reject) => {
      const invokeFunction = function() {
        timerId = null;
        lastInvokeTime = Date.now();
        if (!isImmediate) {
          const result = func.apply(context, args);
          callback && callback(result);
          promises.forEach(({ resolve: resolve2 }) => resolve2(result));
          promises = [];
        }
      };
      const shouldCallNow = isImmediate && timerId === null;
      if (timerId !== null) {
        clearTimeout(timerId);
      }
      timerId = setTimeout(invokeFunction, nextInvokeTimeout());
      if (shouldCallNow) {
        const result = func.apply(context, args);
        callback && callback(result);
        return resolve(result);
      }
      promises.push({ resolve, reject });
    });
  };
  debouncedFunction.cancel = function(reason) {
    if (timerId !== null) {
      clearTimeout(timerId);
    }
    promises.forEach(({ reject }) => reject(reason));
    promises = [];
  };
  return debouncedFunction;
}

function throttle(callback, delay, options = {}) {
  const {
    noTrailing = false,
    noLeading = false,
    debounceMode = void 0
  } = options;
  let timerId = null;
  let cancelled = false;
  let lastExec = 0;
  function clearExistingTimeout() {
    if (timerId) {
      clearTimeout(timerId);
      timerId = null;
    }
  }
  function cancel(options2 = {}) {
    const { upcomingOnly = false } = options2;
    clearExistingTimeout();
    cancelled = !upcomingOnly;
  }
  function wrapper(...args) {
    const self = this;
    const elapsed = Date.now() - lastExec;
    if (cancelled) {
      return;
    }
    function exec() {
      lastExec = Date.now();
      callback.apply(self, args);
    }
    function clear() {
      timerId = null;
    }
    if (!noLeading && debounceMode && !timerId) {
      exec();
    }
    clearExistingTimeout();
    if (debounceMode === void 0 && elapsed > delay) {
      if (noLeading) {
        lastExec = Date.now();
        if (!noTrailing) {
          timerId = setTimeout(debounceMode ? clear : exec, delay);
        }
      } else {
        exec();
      }
    } else if (noTrailing !== true) {
      timerId = setTimeout(debounceMode ? clear : exec, debounceMode === void 0 ? delay - elapsed : delay);
    }
  }
  wrapper.cancel = cancel;
  return wrapper;
}

export { RegEx_Domain, RegEx_Email, RegEx_Password, RegEx_PhoneNumber, RegEx_StrongPassword, capitalizeStr, colorUtils as chalk, convertRgbToHex, copyToClipboard, debounce, errorLog, formatMemoryToMB, formatMsToSecordsStr, generateRandomHex, generateRandomStr, getAverage, getBrowserInfo, getDayOfYear, getNowTimeStr, getPrototype, getPrototypeOf, getRandomNum, getSelectedText, getTimeFromDate, getTwoDaysDiffMS, getUserIp, hasChanged, hasOwnProp, hasOwnProperty, isAppleDevice, isArray, isDarkMode, isDate, isDomainName, isElement, isEmail, isFunction, isMap, isNull, isNumber, isObject, isPhoneNumber, isPlainObject, isPromise, isSet, isString, isSymbol, isUndefined, isValidDate, objectToString, removeArrayItem, reverseStr, stripHtmlEl, throttle, tipLog, toString, toTypeString, truncateStr, uniqArray, warnLog };
